module.exports = __webpack_public_path__ + "img/hint-button.c0f7bc8f.gif";